<script setup>
const props = defineProps({
    isDark: {
        type: Boolean,
        default: false,
    },
});
</script>

<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="13"
        height="18"
        viewBox="0 0 13 18"
        fill="none"
    >
        <path
            d="M7.40208 15.041L7.16135 15.5625C6.79614 15.9401 6.20403 15.9401 5.83883 15.5625L5.6087 15.318L5.5 13.3679L5.5 1.89394C5.5 1.57915 5.59132 1.32418 5.77397 1.12901C5.96271 0.940139 6.2032 0.845703 6.49543 0.845703C6.79376 0.845703 7.03425 0.940139 7.21689 1.12901C7.40563 1.32418 7.5 1.57915 7.5 1.89394L7.5 13.3679L7.40208 15.041Z"
            :fill="isDark ? '#FF6400' : 'black'"
        />
        <path
            d="M11.5 12.1543L7.20711 16.4472C6.81658 16.8377 6.18342 16.8377 5.79289 16.4472L1.5 12.1543"
            :stroke="isDark ? '#FF6400' : 'black'"
            stroke-width="2"
            stroke-linecap="round"
        />
    </svg>
</template>
